import { GtmTracker } from '@/modules/common/services/analytics';

const trackTradeEvent = GtmTracker.trackerWithDefaultProps({
  category: 'Trade'
});

const trackAmplitudeEvent = GtmTracker.trackerWithDefaultProps({
  page_screen: 'asset_list',
  digital_experience: 'investor',
  experience_section: 'broker'
});

export function trackSectionViewLoad(sectionTitle: string) {
  trackAmplitudeEvent({
    event_type: 'load',
    event_name: 'view',
    list_name: sectionTitle
  });
}

export function trackFilterClick(sectionTitle: string, filter: string) {
  trackTradeEvent({
    action: `Filtrou ${filter}`,
    label: 'Busca de Ativos'
  });
  trackAmplitudeEvent({
    event_type: 'click',
    page_screen_section: 'header',
    event_name: 'select_subcategory',
    event_target: filter,
    list_name: sectionTitle
  });
}

export function trackInstrumentClick(
  sectionTitle: string,
  instrumentSymbol: string,
  instrumentName: string
) {
  trackTradeEvent({
    action: `Clique em ${instrumentSymbol}`,
    label: `Lista Setor ${sectionTitle}`
  });
  trackAmplitudeEvent({
    event_type: 'click',
    page_screen_section: 'body',
    event_name: 'select_asset',
    instrument_name: instrumentName,
    instrument_symbol: instrumentSymbol,
    list_name: sectionTitle
  });
}
